import { apiFetch } from "../../../fetchApi"

export const createSkill = ({ BeURL, skills, setSkillList, showAlert, handleTopClear, setIsAdding, candidateId, setCandidate }) => {
    setIsAdding(true)
    apiFetch(`${BeURL}/candidate-skills`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ skills, candidateId })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                showAlert(data.message)
                setSkillList(data.skills)
                // setCandidate(data.candidate)
                handleTopClear()
                window.location.reload()
            }
            else {
                showAlert(data.message)
            }
        })
        .catch(err => {
            console.log("Error to skills add", err)
        })
        .finally(() => setIsAdding(false))
}
